<template>
  <div class="chart-wrapper row justify-content-center">
    <div class="col-md-8 col-12">
      <apexchart
        type="bar"
        :options="chartOptions"
        :series="sanitizedSeries"
      ></apexchart>
    </div>
  </div>
</template>
<script>
var primary = localStorage.getItem("primary_color") || "#5c61f2";
var secondary = localStorage.getItem("secondary_color") || "#eeb82f";
var success = localStorage.getItem("success_color") || "#61ae41";
var info = localStorage.getItem("info_color") || "#4faad5";
const BASE_OPTIONS = {
  chart: {
    height: 350,
    type: "bar",
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: true,
    },
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    categories: [],
  },
  colors: [primary],
  labels: {
    rotate: -45, // Rotación de las etiquetas para mostrar más caracteres
    rotateAlways: true,
  },
};

export default {
  props: {
    labels: {
      type: Array,
      default: () => [],
    },
    series: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    sanitizedLabels() {
      return Array.isArray(this.labels) ? [...this.labels] : [];
    },
    sanitizedSeries() {
      const data = (Array.isArray(this.series) ? this.series : []).map(
        (valor, indice) => ({
          x: this.sanitizedLabels[indice] ?? `${indice + 1}`,
          y: Number(valor) || 0,
        })
      );
      return [
        {
          name: "Tarjetas verificadas",
          data,
        },
      ];
    },
    chartOptions() {
      return {
        ...BASE_OPTIONS,
        xaxis: {
          ...BASE_OPTIONS.xaxis,
          categories: this.sanitizedLabels,
        },
      };
    },
  },
};
</script>
